import { useConditionState } from './useConditionState';
import { getConditionFieldType } from '../utils';

export const useFieldType = () => {
  const [condition] = useConditionState();
  return getConditionFieldType(condition);
};
